import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AddmemotypepopupComponent } from '../../generalpopup/addmemotypepopup/addmemotypepopup.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { HostListener } from '@angular/core';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';

@Component({
  selector: 'app-addmemo',
  templateUrl: './addmemo.component.html',
  styleUrls: ['./addmemo.component.css']
})
export class AddmemoComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "Memo";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  ismemotypeaddmode: boolean = false;

  ismanualclose: boolean;

  isemploading: boolean=false;
  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;
  //Edit Get Values
  memoColl: any = [];
  memoBO: any = {};

  memoid: number = 0

  priorityColl: any = [];

  memotypeColl: any = [];
  empColl: any = [];
  empBO: any = {}

  memoform = new FormGroup({
    memoid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    memotypeid: new FormControl(null, Validators.required),
    memodt: new FormControl(null, Validators.required),
    memodescr: new FormControl(''),
    memotitle: new FormControl(''),
    memonum: new FormControl(''),
    priorityid: new FormControl(null),
    inactive: new FormControl(false),
  });

  dateCustomClasses: DatepickerDateCustomClasses[];
  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.memoid = params.id
      }
    });
    this.fnGetParameterVariable();

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }
  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
    })
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.memoform.reset();
      this.fnInitializeFormGroup();

      if (this.memoid > 0) {
        this.fngetMemo();
      }
      this.fngetMemoType();
      this.fngetEmployee();
      this.fngetPriority();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.memoid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.ismemotypeaddmode= this.loginService.fnCheckUserRoleAction("MemoType", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.memoform.setValue({
      memoid: 0,
      empid: null,
      memotypeid: null,
      memodt: new Date(),
      memotitle: '',
      memonum: '',
      memodescr: '',
      priorityid:null,
      inactive: false
    })
  }

  fngetMemoType() {
    var data = {
      'memoid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getMemoType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.memotypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  
  fngetPriority() {
    var data = {
      'priorityid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.fnGetPriority(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.priorityColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  fngetEmployee() {
    this.isemploading = true;
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading = false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading = false;
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetMemo() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'memoid': this.memoid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.fngetMemo(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.memoColl = res.json().result;
            var editdata = this.memoColl[0];
            this.fnEditMode(editdata);
            this.memoBO = editdata;
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }
  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.memoform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.memoform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'memoid': this.memoid,
          'memodt': this.fnFormatDatetime(this.memoform.get('memodt').value),
          'empid': this.memoform.get('empid').value,
          'memotypeid': this.memoform.get('memotypeid').value,
          'memodescr': this.memoform.get('memodescr').value,
          'memotitle': this.memoform.get('memotitle').value,
          'memonum': this.memoform.get('memonum').value,
          'priorityid': this.memoform.get('priorityid').value,
          //'effectivedt':this.fnFormatDatetime(this.reimburseform.get('effectivedt').value),                  
          'inactive': this.memoform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }



        if (this.memoform.get('memoid').value > 0) {
          //Update 
          this.fnSetMemo(data);
        }
        else {
          //Insert 
          this.fnInsertMemo(data);
        }


      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertMemo(data) {

    this.appService.fnInsertMemo(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The new memo has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));

            var _result = res.json().result;
            if (_result.length > 0) {
              this.fnEditFormEdit(_result[0].memoid);
            }
         
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetMemo(data) {

    this.appService.fnSetMemo(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The memo has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.memoid, this.fngetDescriptionRefno(data));

            this.fnEditFormEdit(this.memoid);
            // this.ismanualclose=true;
            // this.fnCloseForm();              
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }



  //AddMemoType
  private fnAddMemoType() {

    const modalRef = this.productFindService.open(AddmemotypepopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetMemoType();

      if (receivedEntry > 0) {
        this.memoform.patchValue({ memotypeid: receivedEntry })
      }
    });

  }

  fnAddFine(){
   
      try {
        let navigationExtras: NavigationExtras = {
          queryParams: {
          
            'memoid': this.memoid,
            'memoempid':this.memoform.get('empid').value
           
          }
        }
  
        this.router.navigate(['/AddFine'], navigationExtras);
  
      } catch (ex) {
        this.fnShowErrorMsg(ex);
      }
    }

    fnAddActivity(){

      const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
      modalRef.componentInstance.formname = this.formname;
      modalRef.componentInstance.trxid = this.memoid;
  
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {      
  
       
      });
  
    } 
    

  fnEditFormEdit(id) {

    this.memoid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
    }


    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ngOnInit();
    });


  }
  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }


      this.ismanualclose = true;
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'status': this.filterstatus,
          'empid': this.filteremployeeid,
          'empname': this.filteremployeename,
          'fromdate': this.fnFormatDatetime(this.filterfromdate),
          'todate': this.fnFormatDatetime(this.filtertodate),
        }
      }

      this.router.navigate(['/Memo'], navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnEditBtnClick() {
    this.iseditmode = true;
    this.isviewmode = false;
  }

  private fnEditMode(deptBO) {
    deptBO.memodt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.memodt));
    //deptBO.effectivedt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.effectivedt));


    this.memoform.setValue({
      memoid: deptBO.memoid,
      empid: deptBO.empid,
      memotypeid: deptBO.memotypeid,
      memodt: deptBO.memodt,
      memodescr: deptBO.memodescr,
      memotitle: deptBO.memotitle,
      memonum: deptBO.memonum,
      priorityid:deptBO.priorityid,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.isaddmode = false
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;
    this.fnChangeEmpLookup();

    this.fnGetAttachmentCount()
  }

  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.memoid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();

    
    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetMemo();
      }
    });



  }


  fnAttachmentSave(tid) {

  }

  fnSetAttachmentCount(data) {

  }

  
  //Attachment
  fnGetAttachmentCount() {
    if (this.memoid > 0) {
      var data = {
        'trxid': this.memoid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }



  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }

  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  fnResetSaveFlag(){
    this.submitted=false;
    this.successfully=false;
}
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
